export const PERF_ARMS_STORAGE_KEY = 'leadsales_perf_arms_v1';
export const PERF_ARMS_OFF_STORAGE_KEY = 'leadsales_perf_arms_off';
export const PERF_ARMS_OFF_FLAG = 'perf-arms-off';
export const PERF_TAB_NAME_PREFIX = 'leadsales-perf:';

export const PERF_REPLAY_SHARE = 0.1;
export const PERF_REPLAY_SALT = 'replay-holdout-v1';
export const PERF_EXPERIMENTS = {
  perf_s1: { treatmentShare: 0.1, salt: 'board-chat-v1' },
  perf_s2: { treatmentShare: 0.1, salt: 'bubble-isolation-v1' },
} as const;

// Remove each experiment only after its three-weekday safety gate passes.
// This is the current rollout phase, not the share saved by an older tab.
export const PERF_SAFETY_WINDOW_EXPERIMENTS = ['perf_s1', 'perf_s2'] as const;

export const PERF_REPLAY_ARMS = ['recorded', 'holdout'] as const;
export const PERF_STRUCTURAL_ARMS = ['control', 'treatment'] as const;
export const PERF_DRAW_REASONS = ['new_tab', 'auth_reset', 'unavailable'] as const;
